import type { CreateProjectRequest, Project } from "../lib/types";
import { request } from "./client";

export function createProject(payload: CreateProjectRequest): Promise<Project> {
  return request<Project>("/api/v1/projects", {
    method: "POST",
    body: payload,
  });
}

/** ADR 0012 — rename a project (any workspace member). */
export function renameProject(id: string, name: string): Promise<Project> {
  return request<Project>(`/api/v1/projects/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: { name },
  });
}

/** ADR 0012 — delete a project (owner-only; 403 otherwise). */
export function deleteProject(id: string): Promise<void> {
  return request<void>(`/api/v1/projects/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
